import { render, staticRenderFns } from "./paypay.vue?vue&type=template&id=9da2e52a&lang=pug&"
import script from "./paypay.js?vue&type=script&lang=js&"
export * from "./paypay.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports